export class DashboardBroadcastingActivity {

    private nbDevices: number;
    private sumPlaybackSeconds: number;
    private averageActivity: number;

    constructor(nbDevices?: number,
        sumPlaybackSeconds?: number,
        averageActivity?: number) {
            this.nbDevices = nbDevices;
            this.sumPlaybackSeconds = sumPlaybackSeconds;
            this.averageActivity = averageActivity;
        }

    public get NbDevices(): number {
        return this.nbDevices;
    }
    public get SumPlaybackSeconds(): number {
        return this.sumPlaybackSeconds;
    }
    public get AverageActivity(): number {
        return this.averageActivity;
    }


    public set NbDevices(nbDevices: number) {
        this.nbDevices = nbDevices;
    }
    public set SumPlaybackSeconds(sumPlaybackSeconds: number) {
        this.sumPlaybackSeconds = sumPlaybackSeconds;
    }
    public set AverageActivity(averageActivity: number) {
        this.averageActivity = averageActivity;
    }

}
